import moment from 'moment';
import { getVersion } from '../components/util/all';

export enum UserSubscription {
  Trial = 'trial',
  Month = 'month',
  Year = 'year',
  Pay = 'pay',
}

export enum UserType {
  Admin = 'admin',
  User = 'user',
}

export enum Mode {
  Regular = 'regular',
  Conference = 'conference',
  Game = 'game',
  Ticket = 'ticket',
}

export class User {
  id?: number;

  name: string;

  email: string;

  phone: string;

  website: string;

  country: string;

  type: string;

  profile: string | null;

  updatedAt: any;

  subscription: UserSubscription;

  paypalEmail: string;

  logo: string | null;

  whitelabelId: string;

  domainUrl: string;

  adminUrl: string;

  whitelabelEmail: string;

  primaryColor: string;

  secondaryColor: string;

  username: string;

  refer: number;

  company: string;

  videoCredits: number;

  admin: any;

  mpSDK: string;

  googleViewId: string;

  constructor(model: any = {}) {
    this.id = model.id || null;
    this.name = model.name || null;
    this.email = model.email || null;
    this.website = model.website || null;
    this.phone = model.phone || null;
    this.country = model.country || null;
    this.type = model.type || null;
    this.videoCredits = model.videoCredits || 0;
    this.updatedAt = model.updatedAt ? moment(model.updatedAt) : moment();
    this.profile = this.id && model.profile ? `${process.env.REACT_APP_AWS}/users/${this.id}/profile.jpg${getVersion(this.updatedAt)}` : null;
    this.subscription = model.subscription || UserSubscription.Trial;
    this.paypalEmail = model.paypalEmail || null;
    this.whitelabelId = model.whitelabelId || null;
    this.logo = this.id && this.whitelabelId ? `${process.env.REACT_APP_AWS}/users/${this.id}/logo.png${getVersion(this.updatedAt)}` : null;
    this.domainUrl = model.domainUrl || '';
    this.adminUrl = model.adminUrl || '';
    this.whitelabelEmail = model.whitelabelEmail || '';
    this.mpSDK = model.mpSDK || process.env.REACT_APP_MATTERPORT;
    this.primaryColor = model.primaryColor || '#292929';
    this.secondaryColor = model.secondaryColor || '#ea475c';
    this.username = model.username || null;
    this.refer = model.refer || null;
    this.company = model.company || null;
    this.admin = model.admin || null;
    this.googleViewId = model.googleViewId || null;
  }
}
